import zhushou1 from '@/assets/image/zhushou1.png';
import zhushou2 from '@/assets/image/zhushou2.png';
export default {
  name: 'HelperWx',
  props: {},
  data() {
    return {
      showLoginDialog: true
    };
  },
  computed: {
    zhushouImg() {
      return parseInt(Math.random() * 10000) % 2 ? zhushou1 : zhushou2;
    }
  },
  mounted() {},
  methods: {
    handleClose() {
      this.showLoginDialog = false;
    },
    closed() {
      this.$emit('closed');
    }
  }
};